import React from 'react';
import PropTypes from 'prop-types';

function TableBody({ children }) {
    return (
        <div className="table-body">
            {
                children
            }
        </div>
    );
}

TableBody.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default TableBody;
